/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import { Controller } from 'react-hook-form';

function SelectBox({
  label,
  name,
  values = [],
  control,
  placeholder,
  labelstyle,
  // defaultvalue,
  mandatory,
  errors,
  reference,
}) {
  const options = values.map((value) => ({
    label: value.label,
    value: value.value,
  }));
  const colorStyles = {
    control: (defaultStyles) => ({
      ...defaultStyles,
      fontSize: '14px',
      border: '1px solid #e5e7eb',
      borderRadius: '5px',
      minHeight: '50px', // Match input field height (10px top + 10px bottom + 22px content)
      height: '50px',
      boxShadow: 'none',
      '&:hover': {
        border: '1px solid #e5e7eb',
      },
    }),
    valueContainer: (defaultStyles) => ({
      ...defaultStyles,
      padding: '0 12px', // Match input field horizontal padding
      height: '100%',
      display: 'flex',
      alignItems: 'center',
    }),
    input: (defaultStyles) => ({
      ...defaultStyles,
      margin: '0',
      padding: '0',
      height: '100%',
      display: 'flex',
      alignItems: 'center',
    }),
    singleValue: (defaultStyles) => ({
      ...defaultStyles,
      margin: '0',
      padding: '0',
      lineHeight: '1.5',
      color: '#1f2937',
      fontSize: '14px',
      display: 'flex',
      alignItems: 'center',
    }),
    placeholder: (defaultStyles) => ({
      ...defaultStyles,
      fontSize: '14px',
      color: '#9ca3af',
      margin: '0',
      padding: '0',
      lineHeight: '1.5',
      display: 'flex',
      alignItems: 'center',
    }),
    indicatorsContainer: (defaultStyles) => ({
      ...defaultStyles,
      height: '100%',
      padding: '0 8px',
    }),
    indicatorSeparator: () => ({
      display: 'none',
    }),
  };
  const customStyles = {
    control: (base, state) => ({
      ...base,
      background: '#1f2937',
      borderRadius: state.isFocused ? '5px' : '5px',
      border: '1px solid #374151',
      minHeight: '42px',
      height: '42px',
      boxShadow: 'none',
      '&:hover': {
        border: '1px solid #374151',
      },
    }),
    valueContainer: (defaultStyles) => ({
      ...defaultStyles,
      padding: '0 12px',
      height: '100%',
      display: 'flex',
      alignItems: 'center',
    }),
    input: (defaultStyles) => ({
      ...defaultStyles,
      margin: '0',
      padding: '0',
      height: '100%',
      display: 'flex',
      alignItems: 'center',
      color: '#ffffff',
    }),
    singleValue: (defaultStyles) => ({
      ...defaultStyles,
      margin: '0',
      padding: '0',
      lineHeight: '1.5',
      color: '#ffffff',
      fontSize: '14px',
      display: 'flex',
      alignItems: 'center',
    }),
    placeholder: (defaultStyles) => ({
      ...defaultStyles,
      fontSize: '14px',
      color: '#9ca3af',
      margin: '0',
      padding: '0',
      lineHeight: '1.5',
      display: 'flex',
      alignItems: 'center',
    }),
    indicatorsContainer: (defaultStyles) => ({
      ...defaultStyles,
      height: '100%',
      padding: '0 8px',
    }),
    indicatorSeparator: () => ({
      display: 'none',
    }),
  };
  let classNamess = colorStyles;

  if (localStorage.getItem('theme') === 'dark') {
    classNamess = customStyles;
  } else {
    classNamess = colorStyles;
  }
  const handleKeyDown = (e) => {
    if (e.keyCode === 13) {
      const { form } = e.target;
      const index = Array.prototype.indexOf.call(form, e.target);
      form.elements[index + 1].focus();
      e.preventDefault();
    }
  };
  return (
    <div>
      <label className={labelstyle} htmlFor={name} style={{ display: 'inline-block' }}>
        {label ?? 'SelectBox'}
        {mandatory && <span style={{ color: 'red', marginLeft: '3px' }}>*</span>}
      </label>
      <Controller
        name={name}
        control={control}
        rules={{
          required: {
            value: true,
            message: `${label} is required.`,
          },
        }}
        render={({ field: { value, onChange, onBlur } }) => {
          // Handle both object and primitive values
          let selectedValue = null;
          if (value) {
            // If value is an object (from react-select), use it directly
            if (typeof value === 'object' && value !== null && 'value' in value) {
              selectedValue = options.find((o) => o.value === value.value) || null;
            } else {
              // If value is a primitive, find matching option
              selectedValue = options.find((o) => o.value === value) || null;
            }
          }

          // Handle onChange to store just the value (primitive) instead of the whole object
          const handleChange = (selectedOption) => {
            // Store the primitive value, not the object
            onChange(selectedOption ? selectedOption.value : null);
          };

          return (
            <Select
              styles={classNamess}
              options={options}
              onKeyDown={handleKeyDown}
              placeholder={placeholder ?? 'Choose...'}
              onChange={handleChange}
              onBlur={onBlur}
              value={selectedValue}
              ref={reference}
            />
          );
        }}
      />
      <p
        style={{
          color: 'red',
          marginTop: '5px',
          fontSize: '14px',
        }}
      >
        {' '}
        {
          // Shows if error exist
          errors[name] && errors[name].message
        }{' '}
      </p>
    </div>
  );
}

SelectBox.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  values: PropTypes.oneOfType([PropTypes.array]).isRequired,
  control: PropTypes.oneOfType([PropTypes.object]).isRequired,
  placeholder: PropTypes.string,
  labelstyle: PropTypes.string.isRequired,
  mandatory: PropTypes.bool,
  // defaultvalue: PropTypes.string,
  errors: PropTypes.oneOfType([PropTypes.object]).isRequired,
  reference: PropTypes.any,
};

SelectBox.defaultProps = {
  // defaultvalue: '0',
  label: 'SelectBox',
  placeholder: 'Please Select',
  mandatory: false,
  reference: null,
};

SelectBox.defaultValue = {
  mandatory: false,
};

export default SelectBox;
